import { ReactNode } from "react";
import "./NumberedListArticle.scss";

interface Props {
  children: ReactNode | ReactNode[] | undefined;
}

const NumberedListArticle = ({ children }: Props) => (
  <ol className="numbered-list-article-norad">{children}</ol>
);

export default NumberedListArticle;
